import { render, staticRenderFns } from "./BidItem.vue?vue&type=template&id=1836f986"
import script from "./BidItem.vue?vue&type=script&lang=js"
export * from "./BidItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports